import { IconProps } from 'types/icon.type'

export const TrashIcon = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Trash Icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.15533 3.15533C8.88559 3.42507 8.75 3.74392 8.75 4V5.25H15.25V4C15.25 3.74392 15.1144 3.42507 14.8447 3.15533C14.5749 2.88559 14.2561 2.75 14 2.75H10C9.74392 2.75 9.42507 2.88559 9.15533 3.15533ZM16.75 5.25V4C16.75 3.25608 16.3856 2.57493 15.9053 2.09467C15.4251 1.61441 14.7439 1.25 14 1.25H10C9.25608 1.25 8.57493 1.61441 8.09467 2.09467C7.61441 2.57493 7.25 3.25608 7.25 4V5.25H3C2.58579 5.25 2.25 5.58579 2.25 6C2.25 6.41421 2.58579 6.75 3 6.75H4.25V20C4.25 20.7439 4.61441 21.4251 5.09467 21.9053C5.57493 22.3856 6.25608 22.75 7 22.75H17C17.7439 22.75 18.4251 22.3856 18.9053 21.9053C19.3856 21.4251 19.75 20.7439 19.75 20V6.75H21C21.4142 6.75 21.75 6.41421 21.75 6C21.75 5.58579 21.4142 5.25 21 5.25H16.75ZM5.75 6.75V20C5.75 20.2561 5.88559 20.5749 6.15533 20.8447C6.42507 21.1144 6.74392 21.25 7 21.25H17C17.2561 21.25 17.5749 21.1144 17.8447 20.8447C18.1144 20.5749 18.25 20.2561 18.25 20V6.75H5.75ZM10 10.25C10.4142 10.25 10.75 10.5858 10.75 11V17C10.75 17.4142 10.4142 17.75 10 17.75C9.58579 17.75 9.25 17.4142 9.25 17V11C9.25 10.5858 9.58579 10.25 10 10.25ZM14 10.25C14.4142 10.25 14.75 10.5858 14.75 11V17C14.75 17.4142 14.4142 17.75 14 17.75C13.5858 17.75 13.25 17.4142 13.25 17V11C13.25 10.5858 13.5858 10.25 14 10.25Z"
        fill="currentColor"
      />
    </svg>
  )
}
